import React from 'react';
import { Navigate } from 'react-router-dom';

import { Paths } from '../../../shared/paths';
import { useAccess } from '../../../hooks/useAccess';
import { AppConfigurationInnerTabs } from './AppConfigurationInnerTabs';

export default function AppConfiguration() {
  const { access } = useAccess();
  const canViewSection =
    (access?.bugReports?.canViewType ?? false) ||
    (access?.appVariables?.canView ?? false) ||
    (access?.appFeatures?.canView ?? false) ||
    (access?.trainingActivityTypes?.canView ?? false);

  if (!canViewSection) {
    return <Navigate to={Paths.root} replace />;
  }

  return <AppConfigurationInnerTabs />;
}
